// extracted by mini-css-extract-plugin
module.exports = {"img-container":"styles_img-container__3lKW3","img":"styles_img__3D9-Q"};